import { FC, SVGProps } from 'react';

const MessageCloseIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 20,
  color = 'white',
  height = 24,
  width = 24,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.6626 7.30262L8.3349 10.6192M11.6666 10.6233L8.33331 7.30127"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 5.63757C17.5 4.26151 16.3807 3.146 15 3.146H5C3.61929 3.146 2.5 4.26151 2.5 5.63757V16.0211C2.5 16.6898 3.25258 17.0843 3.80549 16.7054L6.2985 14.9969C6.50688 14.8542 6.75384 14.7777 7.00674 14.7777H15C16.3807 14.7777 17.5 13.6622 17.5 12.2861V5.63757Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MessageCloseIcon;
